import { forwardRef, ReactChild } from 'react'
import { ButtonProps } from '@mui/material'
import { StyledButton } from './button.styles'

export type ThemeVariant = 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'ghost' | 'hollow'

type Ref = HTMLButtonElement | null

interface Props extends ButtonProps {
  children: ReactChild
  themevariant?: ThemeVariant
}

const ThemeButton = forwardRef<Ref, Props>(({ className, themevariant = 'primary', children, ...rest }, ref) => (
  <StyledButton
    className={className}
    themevariant={themevariant}
    {...rest}
    ref={ref} // Forward ref to StyledButton
  >
    {children}
  </StyledButton>
))

ThemeButton.displayName = 'ThemeButton' // Optional: for better debugging

export default ThemeButton
